/**
 * Sticky gallery for mobile PDP (treatment only).
 *
 * Moves the collection portal into the gallery's container so they share
 * the same parent. The gallery is position:sticky within that parent,
 * naturally unsticking when the portal (below it) scrolls past.
 *
 * body has overflow-x:hidden which breaks position:sticky (hidden creates a
 * scroll container, so the gallery sticks to it instead of the viewport).
 * Fix: overflow-x CLIP on html+body — clip does NOT create a scroll container
 * (sticky keeps working against the viewport) and, unlike the previous
 * `visible`, it cannot be panned sideways on iOS when any element overflows
 * by a pixel (QA thread: the page could be dragged horizontally). The
 * per-element clips below are kept as harmless belt-and-braces.
 */
(function() {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  var isSurgical = document.documentElement.classList.contains('pdp-surgical-active');

  function fixOverflow() {
    // Enable sticky without enabling sideways pan: the ROOT gets clip (unlike
    // hidden, clip removes the scroll mechanism without creating a scroll
    // container, so it can't be touch-panned and doesn't break sticky). BODY
    // must stay visible: its overflow-y is not visible, so a clip here
    // computes to hidden per the CSS axis-coordination rules — turning body
    // into a scroll container and silently unsticking the gallery.
    document.documentElement.style.overflowX = 'clip';
    document.body.style.overflowX = 'visible';
    document.body.style.maxWidth = '100vw';

    // Clip all elements that overflow horizontally
    document.querySelectorAll('marquee-component, slideshow-component, slideshow-slide, .product-media, .mock-image-container, room-background-mock').forEach(function(el) {
      el.style.overflowX = 'clip';
    });

    var mainSection = document.querySelector('.product-information');
    if (mainSection) {
      for (var i = 0; i < mainSection.children.length; i++) {
        var child = mainSection.children[i];
        if (!child.classList.contains('product-information__media') &&
            !child.classList.contains('product-information__grid')) {
          child.style.overflowX = 'clip';
        }
      }
    }

    var grid = document.querySelector('.product-information__grid');
    if (grid) grid.style.overflowX = 'clip';

    document.querySelectorAll('.shopify-section').forEach(function(sec) {
      if (!sec.querySelector('.product-information')) {
        sec.style.overflowX = 'clip';
      }
    });
  }

  function init() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;

    fixOverflow();

    // Surgical PDP: media container is sticky via CSS; skip portal move and slideshow sticky.
    if (isSurgical) return;

    var portal = document.querySelector('collection-portal');
    if (!portal) return;

    // Move portal into the media container (after the gallery)
    media.appendChild(portal);
    // Reset portal margins/width — originally styled for the details column
    portal.style.margin = '0';
    portal.style.width = '100%';
    portal.style.padding = '12px 14px';

    var headerHeight = parseInt(document.body.style.getPropertyValue('--header-height'))
      || parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'))
      || parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
      || 56;

    // The gallery content (slideshow) is sticky within .product-information__media,
    // which now contains both the slideshow and the portal.
    var slideshow = media.querySelector('media-gallery, gallery-wall-media-gallery');
    if (slideshow) {
      slideshow.style.position = 'sticky';
      slideshow.style.top = headerHeight + 'px';
      slideshow.style.zIndex = '3';
      slideshow.style.background = 'var(--color-background, #fff)';

      // Safari loses hit-testing on sticky elements after tab switch.
      // Force a re-composite when the tab becomes visible again.
      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          slideshow.style.transform = 'translateZ(0)';
          requestAnimationFrame(function() {
            slideshow.style.transform = '';
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }
})();
